import { ScreeningServicePlan } from "common/types/services/api/tenant-screening";
import { ApplicantScreeningReportDto } from "legacy-pages/landlord/profile/background-check/types";
import { axiosInstance } from "./axiosInstance";
import { OffersApiPath } from "common/enums/enums";
import { ScreeningCheckStatus } from "common/types/services/api/offers/offer-item-dto.type";
import RequestedScreeningServicePlan from "common/types/services/api/tenant-screening/RequestedScreeningServicePlan";

export const requestBackgroundCheck = (applicationId: string, orderPlanId: string, screeningCheckStatus: ScreeningCheckStatus): Promise<boolean> => {
  return axiosInstance.post(`${OffersApiPath.MAIN_OFFER_PATH}/${applicationId}/backgroundCheck/request`, { orderPlanId, screeningCheckStatus });
};

export const getApplicantScreeningReport = (userId: string, rentApplicationId: string, location?: string): Promise<ApplicantScreeningReportDto[]> => {
  return axiosInstance.get(`userAccess/backgroundcheck/${userId}?applicationId=${rentApplicationId}&location=${location}`);
};

export const getOrderPlans = (tenantId: string, rentApplcationId: string, location?: string, requestorId?: string): Promise<ScreeningServicePlan[]> => {
  return axiosInstance.get(`userAccess/backgroundcheck/orders?tenantId=${tenantId}&location=${location}&rentApplicationId=${rentApplcationId}&requestorId=${requestorId}`);
};

export const getRequestedOrderPlans = (tenantId: string, requestorId: string, rentApplicationId: string, location?: string): Promise<RequestedScreeningServicePlan[]> => {
  return axiosInstance.get(`userAccess/backgroundcheck/orders/requested?tenantId=${tenantId}&requestorId=${requestorId}&rentApplicationId=${rentApplicationId}&location=${location}`);
};

export const acceptBackgroundCheck = (applicationId: string, orderPlanIds: string[]): Promise<void> => {
  return axiosInstance.post(`${OffersApiPath.MAIN_OFFER_PATH}/${applicationId}/backgroundCheck/accept`, { orderPlanIds });
};

export const declineBackgroundCheck = (applicationId: string, orderPlanIds: string[]): Promise<void> => {
  return axiosInstance.post(`${OffersApiPath.MAIN_OFFER_PATH}/${applicationId}/backgroundCheck/decline`, { orderPlanIds });
};
